(() => {
  if (window.CosmeauCartDrawer) return;

  window.CosmeauCartI18n = window.CosmeauCartI18n || (() => {
    const source = document.querySelector('[data-cosmeau-cart-i18n]');
    if (!source) return {};
    try { return JSON.parse(source.textContent || '{}'); }
    catch (error) { console.error('[CosmeauCart] invalid locale configuration', error); return {}; }
  })();
  const text = (key, variables = {}) => Object.entries(variables).reduce(
    (value, [name, replacement]) => value.replace(
      new RegExp(`{{\\s*${name}\\s*}}`, 'g'),
      String(replacement),
    ),
    String(window.CosmeauCartI18n[key] || ''),
  );
  const cartRoot = document.querySelector('cart-drawer[data-cosmeau-cart]');
  const marketRewardsEnabled = cartRoot?.dataset.cosmeauMarketRewardsEnabled === 'true';
  const marketShippingThresholdMinor = Math.max(0, Number(cartRoot?.dataset.cosmeauShippingRewardThresholdMinor || 1900));
  const marketGiftStripThresholdMinor = Math.max(1, Number(cartRoot?.dataset.cosmeauGiftStripThresholdMinor || 3000));
  const marketGiftPearlsThresholdMinor = Math.max(1, Number(cartRoot?.dataset.cosmeauGiftPearlsThresholdMinor || 4500));
  const marketGiftChoiceThresholdMinor = Math.max(1, Number(cartRoot?.dataset.cosmeauGiftChoiceThresholdMinor || 9000));
  const G6_PRODUCT_ID = 10867957629255;
  const G6_TIN_VARIANT_ID = 54674223071559;
  const DEV_DISCOUNT_THEME_ID = '199614169415';
  const DEV_DISCOUNT_GATE_KEY = '_cosmeau_g6_rewards_dev';
  const DEV_DISCOUNT_GATE_VALUE = '1d155835-c6b6-4f2e-8a9d-5bdcf7a95353';

  const SHEET_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/sheet_hand_8950fcdd-574d-4ce5-9dc8-d0799adec977.jpg?v=1721752078';
  const PEARL_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/all_scents_5b37ba63-0e1f-4e1e-a22e-7088970a5a7e.jpg?v=1715952341';
  const BOX_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/5_colored_full_655ada62-f56c-4cbb-9b91-05910a1439e9.jpg?v=1733820459';
  const CLOTH_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/1_hero_2.jpg?v=1749907015';
  const MASK_KIT_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/kit_5pc_baa43aa7-f1a2-435b-827b-a7ee1b7c69ef.jpg?v=1753887164';
  const TIN_IMAGE = 'https://cdn.shopify.com/s/files/1/0513/6141/5349/files/1_hero_geurparel_tins.png?v=1784719940';
  const choice = (titleKey, variantId, imageUrl) => ({ titleKey, variantId, imageUrl });

  const fallbackConfig = {
    enabled: true,
    rewards: [
      { key: 'shipping-19', labelKey: 'reward_shipping', thresholdMinor: marketShippingThresholdMinor, kind: 'shipping', choices: [] },
      { key: 'gift-strip-30', labelKey: 'reward_strip', thresholdMinor: marketGiftStripThresholdMinor, kind: 'gift', choices: [
        choice('choice_wild_forest', '53950549786951', SHEET_IMAGE),
        choice('choice_lavender', '52541182443847', SHEET_IMAGE),
        choice('choice_sea_breeze', '49913394266439', SHEET_IMAGE),
        choice('choice_toilet_cleaner', '49913394430279', SHEET_IMAGE),
        choice('choice_floor_cleaner', '49913420841287', SHEET_IMAGE),
        choice('choice_dishwasher_tablets', '50379343135047', SHEET_IMAGE),
      ] },
      { key: 'gift-pearls-45', labelKey: 'reward_pearls', thresholdMinor: marketGiftPearlsThresholdMinor, kind: 'gift', choices: [
        choice('choice_lavender', '49913416745287', PEARL_IMAGE),
        choice('choice_spring_fresh', '49913416319303', PEARL_IMAGE),
        choice('choice_wild_forest', '49913417138503', PEARL_IMAGE),
        choice('choice_sea_breeze', '49913416548679', PEARL_IMAGE),
        choice('choice_cherry_blossom', '49913416941895', PEARL_IMAGE),
        choice('choice_pure', '53272141660487', PEARL_IMAGE),
        choice('choice_autumn', '53391881339207', PEARL_IMAGE),
        choice('choice_clouds', '49913417335111', PEARL_IMAGE),
      ] },
      // Oktober 2026 (#481/#483): Mud Mask Starterkit + geurparel-bewaartin (10 geuren). Must equal the Function gift-choice-90 allowlist.
      { key: 'gift-choice-90', labelKey: 'reward_choice', thresholdMinor: marketGiftChoiceThresholdMinor, kind: 'gift', choices: [
        choice('choice_mask_kit', '52129203093831', MASK_KIT_IMAGE),
        choice('choice_tin_spring', '52198227116359', TIN_IMAGE),
        choice('choice_tin_lavender', '52198227149127', TIN_IMAGE),
        choice('choice_tin_sea_breeze', '52198227181895', TIN_IMAGE),
        choice('choice_tin_cherry_blossom', '52198227214663', TIN_IMAGE),
        choice('choice_tin_wild_forest', '52198227247431', TIN_IMAGE),
        choice('choice_tin_summer', '52198227280199', TIN_IMAGE),
        choice('choice_tin_autumn', '52198227312967', TIN_IMAGE),
        choice('choice_tin_clouds', '52224503447879', TIN_IMAGE),
        choice('choice_tin_cozy_winter', '52419729981767', TIN_IMAGE),
        choice('choice_tin_pure', '52419730014535', TIN_IMAGE),
      ] },
    ].sort((left, right) => left.thresholdMinor - right.thresholdMinor),
    upsells: [
      { key: 'scent-pearls', handle: 'geurparels', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'laundry-perfume', handle: 'wasparfum', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'machine-care-tablets', handle: 'wasmachine-diepreinigingstabletten', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'laundry-sheet-box', handle: 'wasstrips-bewaardoos-box', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
      { key: 'dryer-balls', handle: 'drogerballen-6-stuks-met-bewaardoos', triggerHandles: ['wasmiddel-wasstrips-g6', 'wasmiddel-wasstrips'] },
    ],
  };

  const money = (minor) => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(minor / 100);
  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const plainProductText = (value) => {
    const parsed = new DOMParser().parseFromString(String(value || ''), 'text/html');
    return String(parsed.body.textContent || '').replace(/\s+/g, ' ').trim();
  };
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let config = fallbackConfig;
  const MAX_REMOTE_REWARD_THRESHOLD_MINOR = 10000000;
  const MAX_REMOTE_GIFT_CHOICES = 50;
  const MAX_REMOTE_TITLE_LENGTH = 120;
  const MAX_REMOTE_METADATA_LENGTH = 160;
  const MAX_REMOTE_IMAGE_URL_LENGTH = 2048;
  let syncing = false;
  let queuedCart = null;
  let renderedFingerprint = '';
  let pendingWasEmpty = false;
  let recommendationRun = 0;
  let recommendationAnchor = null;
  const recommendationProducts = new Map();
  const pendingRewardKeys = new Set();
  const CHECKOUT_SELECTOR = '#CartDrawer-Checkout, #juo-go-to-checkout-with-ideal';
  let checkoutWarningBypass = null;
  let giftInteractionTimer = 0;
  let giftWarningEscapeBlockUntil = 0;

  const CURATED_LAUNDRY_HANDLES = [
    'geurparels',
    'wasparfum',
    'wasmachine-diepreinigingstabletten',
    'wasstrips-bewaardoos-box',
    'drogerballen-6-stuks-met-bewaardoos',
  ];


  function showPendingItem(product) {
    const root = document.querySelector('cart-drawer[data-cosmeau-cart]');
    const holder = root?.querySelector('#CartDrawer-CartItems');
    if (!root || !holder) return;
    clearPendingItem();
    pendingWasEmpty = root.classList.contains('is-empty');
    root.classList.toggle('pending-from-empty', pendingWasEmpty);
    root.classList.remove('is-empty');
    root.classList.add('is-cart-loading', 'has-pending-item');
    root.querySelector('cart-drawer-items')?.classList.remove('is-empty');
    const count = Math.max(1, Number(product?.quantity || 1));
    const image = product?.imageUrl
      ? `<img src="${escapeHtml(product.imageUrl)}" alt="" width="64" height="64">`
      : '<span class="cosmeau-cart__pending-placeholder" aria-hidden="true"></span>';
    const quantityCopy = count > 1 ? text('pending_quantity', { count }) : '';
    holder.insertAdjacentHTML('afterbegin', `<div class="cosmeau-cart__pending-item" data-cosmeau-pending-item role="status" aria-live="polite">${image}<span class="cosmeau-cart__pending-copy"><strong>${escapeHtml(product?.title || text('generic_product'))}</strong>${product?.variantTitle ? `<small>${escapeHtml(product.variantTitle)}</small>` : ''}<small>${escapeHtml(quantityCopy)}${escapeHtml(text('pending_add'))}</small></span><span class="cosmeau-cart__pending-spinner" aria-hidden="true"></span></div>`);
    const itemCount = root.querySelector('[data-cosmeau-cart-count]');
    if (itemCount && pendingWasEmpty) itemCount.textContent = text('pending_add');
  }

  function clearPendingItem(restoreEmpty = false) {
    const root = document.querySelector('cart-drawer[data-cosmeau-cart]');
    root?.querySelector('[data-cosmeau-pending-item]')?.remove();
    root?.classList.remove('has-pending-item', 'pending-from-empty', 'is-cart-loading');
    if (restoreEmpty && pendingWasEmpty) {
      root?.classList.add('is-empty');
      root?.querySelector('cart-drawer-items')?.classList.add('is-empty');
    }
    pendingWasEmpty = false;
  }

  async function fetchCart() {
    const response = await fetch(`${rootUrl()}cart.js`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(text('cart_load_error'));
    return response.json();
  }

  const isSharedUnpublishedDevTheme = () => {
    const theme = window.Shopify?.theme;
    return String(theme?.id || '') === DEV_DISCOUNT_THEME_ID
      && String(theme?.role || '').toLowerCase() === 'unpublished';
  };
  let devDiscountGatePromise = null;
  async function ensureDevDiscountGate() {
    if (!isSharedUnpublishedDevTheme()) return null;
    if (!devDiscountGatePromise) {
      devDiscountGatePromise = (async () => {
        const cart = await fetchCart();
        if (cart.attributes?.[DEV_DISCOUNT_GATE_KEY] === DEV_DISCOUNT_GATE_VALUE) return cart;
        const response = await fetch(`${rootUrl()}cart/update.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              ...(cart.attributes || {}),
              [DEV_DISCOUNT_GATE_KEY]: DEV_DISCOUNT_GATE_VALUE,
            },
          }),
        });
        if (!response.ok) throw new Error('DEV discount gate update failed');
        return response.json();
      })();
    }
    try { return await devDiscountGatePromise; }
    catch (error) { devDiscountGatePromise = null; throw error; }
  }

  const cartFingerprint = (cart) => JSON.stringify({
    count: cart.item_count,
    total: cart.total_price,
    discount: cart.total_discount,
    items: (cart.items || []).map((item) => [item.key, item.quantity, item.final_line_price, item.selling_plan_allocation?.selling_plan?.id || '']),
  });
  const isAutomaticRewardItem = (item) => Boolean(item?.properties?._cosmeau_auto_reward_key);
  const isLegacyRewardItem = (item) => Boolean(item?.properties?._cosmeau_reward_key);
  const isG6TinItem = (item) => Number(item?.variant_id) === G6_TIN_VARIANT_ID;
  const isProgressRewardItem = (item) => isAutomaticRewardItem(item) || isLegacyRewardItem(item);
  const isRewardItem = (item) => isProgressRewardItem(item) || isG6TinItem(item);
  const g6Quantity = (items) => (items || []).reduce(
    (sum, item) => sum + (Number(item?.product_id) === G6_PRODUCT_ID ? Number(item?.quantity || 0) : 0),
    0,
  );
  const eligibleTotal = (cart) => {
    const items = cart?.items || [];
    const totalAfterDiscounts = Number(cart?.total_price);
    if (Number.isFinite(totalAfterDiscounts)) {
      const rewardTotal = items.reduce(
        (sum, item) => sum + (isRewardItem(item) ? Number(item.final_line_price || 0) : 0),
        0
      );
      return Math.max(0, totalAfterDiscounts - rewardTotal);
    }
    return items.reduce(
      (sum, item) => sum + (isRewardItem(item) ? 0 : Number(item.final_line_price || 0)),
      0
    );
  };
  const nextReward = (total) => marketRewardsEnabled
    ? config.rewards.find((reward) => total < reward.thresholdMinor) || null
    : null;

  function progressPercent(total) {
    const thresholds = config.rewards.map((reward) => reward.thresholdMinor);
    const count = thresholds.length;
    if (!count || total <= 0) return 0;
    const reached = thresholds.filter((threshold) => total >= threshold).length;
    if (reached >= count) return 100;
    const lower = reached ? thresholds[reached - 1] : 0;
    const upper = thresholds[reached];
    const lowerPosition = reached ? ((reached - 0.5) / count) * 100 : 0;
    const upperPosition = ((reached + 0.5) / count) * 100;
    return lowerPosition + ((total - lower) / Math.max(1, upper - lower)) * (upperPosition - lowerPosition);
  }

  const selectedRewardKeys = (cart) => new Set((cart.items || []).filter(isAutomaticRewardItem).map((item) => item.properties._cosmeau_auto_reward_key));

  async function refreshSections(open = true) {
    const sectionUrl = `${rootUrl()}?sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`;
    const [sectionsResponse, cart] = await Promise.all([
      fetch(sectionUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }),
      fetchCart(),
    ]);
    if (!sectionsResponse.ok) throw new Error(text('cart_refresh_error'));
    const sections = await sectionsResponse.json();
    if (!sections || typeof sections !== 'object' || Array.isArray(sections)) throw new Error(text('cart_refresh_error'));
    for (const [key, selector] of [['cart-drawer', 'cart-drawer[data-cosmeau-cart]'], ['cart-icon-bubble', 'svg']]) {
      const html = sections[key];
      if (typeof html !== 'string' || !html.trim() || !new DOMParser().parseFromString(html, 'text/html').querySelector(selector)) {
        throw new Error(text('cart_refresh_error'));
      }
    }
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    drawer?.patchDynamicRegions?.(sections['cart-drawer']);
    drawer?.patchCartIcon?.(sections['cart-icon-bubble']);
    await sync(cart);
    if (open) drawer?.open?.();
    else drawer?.close?.();
    document.dispatchEvent(new CustomEvent('cart_changed', { detail: { source: 'cosmeau-cart', cart } }));
    return cart;
  }

  const automaticRewardIsCurrent = (item, total) => {
    if (!isAutomaticRewardItem(item)) return false;
    const key = item.properties._cosmeau_auto_reward_key;
    const reward = config.rewards.find((candidate) => candidate.key === key && candidate.kind === 'gift');
    if (!reward || total < reward.thresholdMinor) return false;
    return reward.choices.some((choice) => Number(choice.variantId) === Number(item.variant_id));
  };

  const rewardLineIsInvalid = (item, total, removeAllRewards = false) => {
    if (!isProgressRewardItem(item)) return false;
    if (removeAllRewards || isLegacyRewardItem(item)) return true;
    if (isAutomaticRewardItem(item) && Number(item.quantity) !== 1) return true;
    return isAutomaticRewardItem(item) && !automaticRewardIsCurrent(item, total);
  };

  const invalidRewardLines = (items, total, removeAllRewards = false) => {
    const seenAutomaticKeys = new Set();
    let seenG6Tin = false;
    const g6Total = g6Quantity(items);
    return (items || []).filter((item) => {
      if (isG6TinItem(item)) {
        const invalidTin = g6Total < 8 || Number(item.quantity) !== 1 || seenG6Tin;
        seenG6Tin = true;
        return invalidTin;
      }
      if (rewardLineIsInvalid(item, total, removeAllRewards)) return true;
      if (!isAutomaticRewardItem(item)) return false;
      const key = item.properties._cosmeau_auto_reward_key;
      if (seenAutomaticKeys.has(key)) return true;
      seenAutomaticKeys.add(key);
      return false;
    });
  };

  async function removeInvalidRewards(cart, total, removeAllRewards = false) {
    const invalid = invalidRewardLines(cart.items, total, removeAllRewards);
    if (!invalid.length) return null;
    const updates = Object.fromEntries(invalid.map((item) => [item.key, 0]));
    const response = await fetch(`${rootUrl()}cart/update.js`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    });
    const updated = await response.json();
    if (!response.ok || updated?.errors) throw new Error(updated?.description || updated?.errors || text('invalid_reward_remove_error'));
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    drawer?.patchDynamicRegions?.(updated.sections?.['cart-drawer']);
    drawer?.patchCartIcon?.(updated.sections?.['cart-icon-bubble']);
    return updated;
  }

  async function reconcileRewards(cart) {
    if (!cart || !Array.isArray(cart.items)) return cart;
    const total = eligibleTotal(cart);
    return await removeInvalidRewards(cart, total, !marketRewardsEnabled) || cart;
  }

  function renderRewards(root, cart, total) {
    const itemCount = Number.isFinite(Number(cart?.item_count))
      ? Number(cart.item_count)
      : (cart?.items || []).reduce((sum, item) => sum + Number(item?.quantity || 0), 0);
    const count = root.querySelector('[data-cosmeau-cart-count]');
    if (count) count.textContent = `${itemCount} ${text(itemCount === 1 ? 'item_one' : 'item_other')}`;
    document.querySelectorAll('.cosmeau-v6-header__cart-count').forEach((node) => { node.textContent = itemCount; });
    const shippingReward = marketRewardsEnabled ? config.rewards.find((reward) => reward.kind === 'shipping') : null;
    const shippingSummary = root.querySelector('[data-cosmeau-cart-shipping-summary]');
    if (shippingSummary) {
      const shippingReached = Boolean(shippingReward && total >= shippingReward.thresholdMinor);
      shippingSummary.classList.toggle('is-free', shippingReached);
      shippingSummary.textContent = text(shippingReached ? 'free' : 'checkout_shipping');
    }
    root.querySelectorAll('[data-cosmeau-reward-milestone]').forEach((node) => {
      const reward = marketRewardsEnabled ? config.rewards.find((candidate) => candidate.key === node.dataset.rewardKey) : null;
      node.hidden = !reward;
      if (!reward) return;
      node.dataset.thresholdMinor = String(reward.thresholdMinor);
      const label = reward.label || text(reward.labelKey);
      node.setAttribute('aria-label', label);
      const copy = node.querySelector('b');
      if (copy) copy.textContent = label;
      node.classList.toggle('is-reached', total >= reward.thresholdMinor);
    });
    if (!marketRewardsEnabled) {
      const rewards = root.querySelector('[data-cosmeau-cart-rewards]');
      if (rewards) rewards.hidden = true;
      return;
    }
    const next = nextReward(total);
    const progress = root.querySelector('[data-cosmeau-cart-progress]');
    if (progress) {
      const percent = Math.min(100, Math.max(0, progressPercent(total)));
      progress.style.width = `${percent}%`;
      progress.dataset.progress = String(percent);
    }
    const message = root.querySelector('[data-cosmeau-cart-next]');
    if (message) message.innerHTML = next
      ? text(next.kind === 'shipping' ? 'shipping_remaining_html' : 'gift_remaining_html', {
        amount: escapeHtml(money(next.thresholdMinor - total)),
      })
      : text('all_rewards_unlocked_html');

    const giftHolder = root.querySelector('[data-cosmeau-cart-gifts]');
    if (!giftHolder) return;
    const selected = selectedRewardKeys(cart);
    const available = config.rewards.find((reward) => reward.kind === 'gift' && total >= reward.thresholdMinor && !selected.has(reward.key) && reward.choices?.length);
    if (!available) { giftHolder.innerHTML = ''; return; }
    const choices = available.choices.map((item) => `<button class="cosmeau-cart__gift" type="button" data-cosmeau-gift data-key="${escapeHtml(available.key)}" data-threshold="${available.thresholdMinor}" data-variant="${escapeHtml(item.variantId)}"><img src="${escapeHtml(item.imageUrl)}" alt="" width="70" height="70" loading="lazy"><span>${escapeHtml(item.title || text(item.titleKey))}</span></button>`).join('');
    const choiceCount = text(available.choices.length === 1 ? 'choice_one' : 'choice_other', { count: available.choices.length });
    giftHolder.innerHTML = `<div class="cosmeau-cart__gift-panel is-gift-attention" data-reward-key="${escapeHtml(available.key)}"><div class="cosmeau-cart__gift-heading"><p class="cosmeau-cart__gift-title">🎁 ${escapeHtml(available.label || text(available.labelKey))}, ${escapeHtml(text('gift_choose'))} <span>${escapeHtml(choiceCount)}</span></p><div class="cosmeau-cart__gift-arrows"><button type="button" data-cosmeau-gift-scroll="-1" aria-label="${escapeHtml(text('previous_gifts'))}">‹</button><button type="button" data-cosmeau-gift-scroll="1" aria-label="${escapeHtml(text('more_gifts'))}">›</button></div></div><div class="cosmeau-cart__gift-choices" data-cosmeau-gift-track>${choices}</div></div>`;
  }

  function missingGiftPanel(checkoutControl) {
    const root = checkoutControl?.closest?.('[data-cosmeau-cart]') || document.querySelector('[data-cosmeau-cart]');
    const panel = root?.querySelector('.cosmeau-cart__gift-panel');
    if (!panel || panel.closest('[hidden]')) return null;
    const style = window.getComputedStyle(panel);
    return style.display !== 'none' && style.visibility !== 'hidden' ? panel : null;
  }

  function pauseGiftAttention(panel, duration = 1400) {
    if (!panel) return;
    panel.classList.add('is-gift-interacting');
    window.clearTimeout(giftInteractionTimer);
    giftInteractionTimer = window.setTimeout(() => {
      panel.classList.remove('is-gift-interacting');
    }, duration);
  }

  function restartGiftAttention(panel) {
    if (!panel) return;
    panel.classList.remove('is-gift-interacting', 'is-gift-attention');
    void panel.offsetWidth;
    panel.classList.add('is-gift-attention');
  }

  function closeGiftWarning(chooseGift = false) {
    const warning = document.querySelector('[data-cosmeau-gift-warning]');
    if (!warning || warning.hidden) return;
    const checkoutControl = warning._checkoutControl;
    const panel = missingGiftPanel(checkoutControl);
    warning.hidden = true;
    warning._checkoutControl = null;
    document.querySelector('[data-cosmeau-cart]')?.classList.remove('is-gift-warning-open');
    if (chooseGift && panel) {
      const scroller = panel.closest('.cosmeau-cart__scroll-body');
      if (scroller) {
        // Scroll only the cart, not the page behind it. Finish before moving focus.
        const top = scroller.scrollTop + panel.getBoundingClientRect().top
          - scroller.getBoundingClientRect().top - scroller.clientTop - 12;
        scroller.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
      } else {
        panel.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
      }
      restartGiftAttention(panel);
      (panel.querySelector('[data-cosmeau-gift]:not([disabled])') || panel).focus?.({ preventScroll: true });
      return;
    }
    checkoutControl?.focus?.({ preventScroll: true });
  }

  function openGiftWarning(checkoutControl) {
    const warning = document.querySelector('[data-cosmeau-gift-warning]');
    if (!warning || !missingGiftPanel(checkoutControl)) return false;
    warning._checkoutControl = checkoutControl;
    warning.hidden = false;
    document.querySelector('[data-cosmeau-cart]')?.classList.add('is-gift-warning-open');
    warning.querySelector('[data-cosmeau-gift-warning-choose]')?.focus();
    return true;
  }

  function guardCheckoutEvent(event, checkoutControl) {
    if (!checkoutControl || checkoutWarningBypass === checkoutControl) return false;
    if (!openGiftWarning(checkoutControl)) return false;
    event?.preventDefault?.();
    event?.stopImmediatePropagation?.();
    return true;
  }

  function continueCheckoutFromGiftWarning() {
    const warning = document.querySelector('[data-cosmeau-gift-warning]');
    const checkoutControl = warning?._checkoutControl;
    if (!checkoutControl?.isConnected) {
      closeGiftWarning(false);
      return;
    }
    checkoutWarningBypass = checkoutControl;
    closeGiftWarning(false);
    checkoutControl.click();
    window.setTimeout(() => {
      if (checkoutWarningBypass === checkoutControl) checkoutWarningBypass = null;
    }, 1000);
  }

  function normalizeRecommendedProduct(product) {
    if (!product?.handle) return null;
    const variants = (product.variants || []).filter((variant) => variant.available !== false).map((variant) => ({
      id: Number(variant.id),
      title: String(variant.title || text('default_variant')),
      price: Number(variant.price || 0),
    })).filter((variant) => variant.id);
    if (!variants.length) return null;
    const rawImage = product.featured_image?.src || product.featured_image || product.images?.[0]?.src || product.images?.[0] || '';
    return {
      id: Number(product.id || 0),
      handle: String(product.handle),
      title: String(product.title || ''),
      type: String(product.type || ''),
      tags: Array.isArray(product.tags) ? product.tags : [],
      imageUrl: String(rawImage).startsWith('//') ? `https:${rawImage}` : String(rawImage),
      descriptionHtml: String(product.description || product.body_html || ''),
      shortDescription: plainProductText(product.description || product.body_html).slice(0, 160),
      variants,
      priceMinor: Math.min(...variants.map((variant) => variant.price)),
    };
  }

  async function fetchProduct(handle) {
    const cached = recommendationProducts.get(handle);
    if (cached) return cached;
    const response = await fetch(`${rootUrl()}products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin', cache: 'force-cache', headers: { Accept: 'application/json' },
    });
    if (!response.ok) return null;
    const product = normalizeRecommendedProduct(await response.json());
    if (product) recommendationProducts.set(product.handle, product);
    return product;
  }

  async function fetchComplementary(productId) {
    if (!productId) return [];
    const query = new URLSearchParams({ product_id: String(productId), limit: '8', intent: 'complementary' });
    const response = await fetch(`${rootUrl()}recommendations/products.json?${query}`, {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
    });
    if (!response.ok) return [];
    const data = await response.json();
    return (data.products || []).map(normalizeRecommendedProduct).filter(Boolean);
  }

  const isLaundryRecommendation = (product) => {
    const haystack = `${product.type} ${(product.tags || []).join(' ')} ${product.handle}`.toLowerCase();
    return /(laundry|wasparfum|wasmachine|wasstrips|scent|geurparel|dryer|droger)/.test(haystack)
      && !/(dishwasher|vaatwas|cleaning tab)/.test(haystack);
  };

  function recommendationAnchorItem(cartItems) {
    if (!cartItems.length) {
      recommendationAnchor = null;
      return null;
    }
    const existing = recommendationAnchor
      ? cartItems.find((item) => Number(item.product_id) === Number(recommendationAnchor.product_id))
      : null;
    if (existing) return existing;
    const core = cartItems.find((item) => /^(wasmiddel-wasstrips-g6|wasmiddel-wasstrips)$/.test(String(item.handle || '')));
    const anchor = core || cartItems[cartItems.length - 1];
    recommendationAnchor = { product_id: anchor?.product_id, handle: anchor?.handle };
    return anchor;
  }

  async function recommendationSet(cart) {
    const cartItems = (cart.items || []).filter((item) => !isRewardItem(item));
    const anchor = recommendationAnchorItem(cartItems);
    const cartHandles = new Set(cartItems.map((item) => item.handle));
    const triggerHandles = new Set(cartHandles);
    const configured = (config.upsells || []).filter((item) => !item.triggerHandles?.length || item.triggerHandles.some((handle) => triggerHandles.has(handle)));
    const curatedHandles = configured.map((item) => item.handle).filter(Boolean);
    const laundryCart = /(wasmiddel|wasstrip|wasparfum|geurparel|droger|laundry)/i.test(`${anchor?.handle || ''} ${anchor?.product_type || ''}`);
    const preferredHandles = curatedHandles.length ? curatedHandles : (laundryCart ? CURATED_LAUNDRY_HANDLES : []);
    const [curated, complementary] = await Promise.all([
      Promise.all(preferredHandles.map(fetchProduct)),
      fetchComplementary(anchor?.product_id),
    ]);
    const result = [];
    const seen = new Set(anchor?.handle ? [anchor.handle] : []);
    const relevantComplementary = laundryCart ? complementary.filter(isLaundryRecommendation) : complementary;
    [...curated.filter(Boolean), ...relevantComplementary].forEach((product) => {
      if (!product || seen.has(product.handle) || result.length >= 8) return;
      seen.add(product.handle);
      recommendationProducts.set(product.handle, product);
      result.push(product);
    });
    return result;
  }

  async function renderUpsell(root, cart) {
    const section = root.querySelector('[data-cosmeau-cart-upsell]');
    const holder = root.querySelector('[data-cosmeau-cart-upsell-content]');
    if (!section || !holder) return;
    const previousScroll = holder.querySelector('[data-cosmeau-upsell-track]')?.scrollLeft || 0;
    const run = ++recommendationRun;
    let products = [];
    try { products = await recommendationSet(cart); }
    catch (error) { console.warn('[CosmeauCart] recommendations unavailable', error); }
    if (run !== recommendationRun) return;
    if (!products.length) { section.hidden = true; holder.innerHTML = ''; return; }
    const cards = products.map((product) => {
      const priceLabel = product.variants.length === 1 ? money(product.priceMinor) : text('from_price', { price: money(product.priceMinor) });
      const image = product.imageUrl
        ? `<img src="${escapeHtml(product.imageUrl)}" alt="" width="64" height="64" loading="lazy">`
        : '<span class="cosmeau-cart__upsell-image-placeholder" aria-hidden="true"></span>';
      return `<button type="button" class="cosmeau-cart__upsell-card" data-cosmeau-upsell-product="${escapeHtml(product.handle)}" aria-label="${escapeHtml(text('choose_product', { product: product.title }))}">${image}<span class="cosmeau-cart__upsell-copy"><span class="cosmeau-cart__upsell-title">${escapeHtml(product.title)}</span><span class="cosmeau-cart__upsell-price">${escapeHtml(priceLabel)}</span></span></button>`;
    }).join('');
    holder.innerHTML = `<div class="cosmeau-cart__upsell-track" data-cosmeau-upsell-track>${cards}</div>`;
    const nextTrack = holder.querySelector('[data-cosmeau-upsell-track]');
    if (nextTrack && previousScroll) requestAnimationFrame(() => { nextTrack.scrollLeft = previousScroll; });
    section.hidden = false;
  }

  function renderMiniPdp(scope, product) {
    const api = window.CosmeauProductSnapshot;
    const locale = (document.documentElement.lang || 'nl').toLowerCase().split('-')[0];
    const resolved = api?.resolveSnapshot({
      productId: product.id,
      productHandle: product.handle,
      descriptionHtml: product.descriptionHtml || '',
      locale,
    }) || { benefits: [], icons: [], topics: [], summary: product.shortDescription || '' };
    const benefits = scope?.querySelector('[data-cosmeau-mini-pdp-benefits]');
    const accordion = scope?.querySelector('[data-cosmeau-mini-pdp-accordion]');

    if (benefits) {
      benefits.replaceChildren();
      resolved.benefits.slice(0, 4).forEach((text, index) => {
        const item = document.createElement('div');
        item.className = 'cosmeau-cart__mini-pdp-benefit';
        const icon = document.createElement('span');
        icon.className = 'cosmeau-cart__mini-pdp-benefit-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = resolved.icons[index] || '✅';
        const copy = document.createElement('span');
        copy.textContent = text;
        item.append(icon, copy);
        benefits.append(item);
      });
      benefits.hidden = !resolved.benefits.length;
    }

    if (accordion) {
      accordion.replaceChildren();
      const topics = resolved.topics.length
        ? resolved.topics
        : (product.shortDescription ? [{ title: text('product_description'), text: product.shortDescription }] : []);
      topics.slice(0, 4).forEach((topic, index) => {
        const details = document.createElement('details');
        details.className = 'cosmeau-cart__mini-pdp-topic';
        details.open = index === 0;
        const summary = document.createElement('summary');
        summary.textContent = topic.title || text('product_description');
        const body = document.createElement('p');
        body.textContent = topic.text;
        details.append(summary, body);
        accordion.append(details);
      });
      accordion.hidden = !topics.length;
    }
    return resolved;
  }

  function focusableSheetElements(sheet) {
    if (!sheet) return [];
    const selector = [
      'a[href]',
      'button:not([disabled])',
      'summary',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',');
    return [...sheet.querySelectorAll(selector)].filter((element) => {
      const style = window.getComputedStyle(element);
      return !element.hidden && style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  function trapSheetFocus(event, sheet) {
    if (event.key !== 'Tab' || !sheet) return;
    const focusable = focusableSheetElements(sheet);
    if (!focusable.length) {
      event.preventDefault();
      sheet.setAttribute('tabindex', '-1');
      sheet.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !sheet.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !sheet.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  function closeVariantSheet() {
    const sheet = document.querySelector('[data-cosmeau-variant-sheet]');
    if (!sheet) return;
    sheet.hidden = true;
    sheet.querySelector('[data-cosmeau-variant-options]').innerHTML = '';
    document.querySelector('cart-drawer[data-cosmeau-cart]')?.classList.remove('is-variant-sheet-open');
  }

  function openProductSheet(trigger) {
    const root = document.querySelector('[data-cosmeau-cart]');
    const sheet = document.querySelector('[data-cosmeau-product-sheet]');
    if (!sheet || !trigger) return;
    const title = sheet.querySelector('[data-cosmeau-product-title]');
    const option = sheet.querySelector('[data-cosmeau-product-option]');
    const desc = sheet.querySelector('[data-cosmeau-product-desc]');
    const price = sheet.querySelector('[data-cosmeau-product-price]');
    const link = sheet.querySelector('[data-cosmeau-product-link]');
    if (title) title.textContent = trigger.dataset.infoTitle || '';
    if (option) option.textContent = trigger.dataset.infoOpt ? text('variant_label', { variant: trigger.dataset.infoOpt }) : '';
    const descriptionHtml = trigger.closest('.cart-item')?.querySelector('[data-cosmeau-product-description-source]')?.value || '';
    const product = {
      id: Number(trigger.dataset.infoProductId || 0),
      handle: trigger.dataset.infoHandle || '',
      descriptionHtml,
      shortDescription: trigger.dataset.infoDesc || '',
    };
    const resolved = renderMiniPdp(sheet, product);
    if (desc) desc.textContent = resolved.summary || product.shortDescription;
    if (price) price.textContent = trigger.dataset.infoPrice || '';
    if (link) {
      link.href = trigger.dataset.infoUrl || '#';
      link.hidden = !trigger.dataset.infoUrl;
    }
    const imageSrc = trigger.dataset.infoImage;
    const imgEl = sheet.querySelector('#CosmeauProductSheetImage');
    if (imgEl) {
      if (imageSrc) { imgEl.src = imageSrc; imgEl.hidden = false; }
      else { imgEl.removeAttribute('src'); imgEl.hidden = true; }
    }
    sheet.hidden = false;
    sheet._returnFocus = trigger;
    root?.classList.add('is-product-sheet-open');
    sheet.querySelector('[data-cosmeau-product-close]')?.focus();
  }

  function closeProductSheet() {
    const sheet = document.querySelector('[data-cosmeau-product-sheet]');
    if (!sheet) return;
    sheet.hidden = true;
    document.querySelector('cart-drawer[data-cosmeau-cart]')?.classList.remove('is-product-sheet-open');
  }

  function openVariantSheet(product, returnFocus) {
    const sheet = document.querySelector('[data-cosmeau-variant-sheet]');
    const title = sheet?.querySelector('[data-cosmeau-variant-title]');
    const image = sheet?.querySelector('[data-cosmeau-variant-image]');
    const description = sheet?.querySelector('[data-cosmeau-variant-description]');
    const price = sheet?.querySelector('[data-cosmeau-variant-price]');
    const options = sheet?.querySelector('[data-cosmeau-variant-options]');
    if (!sheet || !title || !options) return;
    title.textContent = product.title;
    if (image) {
      image.src = product.imageUrl || '';
      image.alt = product.title || '';
      image.hidden = !product.imageUrl;
    }
    const resolved = renderMiniPdp(sheet, product);
    if (description) description.textContent = resolved.summary || product.shortDescription || text('upsell_fallback');
    if (price) price.textContent = product.variants.length > 1 ? text('from_price', { price: money(product.priceMinor) }) : money(product.priceMinor);
    options.innerHTML = product.variants.map((variant) => {
      const label = product.variants.length === 1 || variant.title === 'Default Title' ? text('add_to_cart') : variant.title;
      return `<button type="button" data-cosmeau-upsell-variant="${variant.id}" data-cosmeau-upsell-handle="${escapeHtml(product.handle)}"><span>${escapeHtml(label)}</span><strong>${escapeHtml(money(variant.price))}</strong></button>`;
    }).join('');
    sheet.hidden = false;
    sheet._returnFocus = returnFocus;
    document.querySelector('cart-drawer[data-cosmeau-cart]')?.classList.add('is-variant-sheet-open');
    sheet.querySelector('[data-cosmeau-upsell-variant]')?.focus();
  }


  async function addItems(items) {
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    const payload = { items };
    if (drawer?.getSectionsToRender) {
      payload.sections = drawer.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;
    }
    const response = await fetch(`${rootUrl()}cart/add.js`, {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    if (!response.ok || data?.status) throw new Error(data?.description || text('product_add_error'));
    if (drawer?.renderContents && data.sections) drawer.renderContents(data);
    else await refreshSections();
    const cart = await fetchCart();
    await sync(cart);
    document.dispatchEvent(new CustomEvent('cart_changed', { detail: { source: 'cosmeau-cart', cart } }));
    return { data, cart };
  }

  async function preserveG6TinAfterRewardAdd(beforeCart, afterCart) {
    const hadTinBefore = (beforeCart?.items || []).some(isG6TinItem);
    if (!hadTinBefore || g6Quantity(afterCart?.items) < 8) return afterCart;
    if ((afterCart?.items || []).some(isG6TinItem)) {
      try { return await refreshSections(true); }
      catch (error) {
        console.warn('[CosmeauCart] G6 gift section refresh unavailable', error);
        return afterCart;
      }
    }
    const restored = await addItems([{
      id: G6_TIN_VARIANT_ID,
      quantity: 1,
      properties: { _g6_gift: 'jaarvoorraad-bewaarblik' },
    }]);
    return restored.cart;
  }

  async function addGift(button) {
    const rewardKey = button.dataset.key;
    if (!rewardKey || pendingRewardKeys.has(rewardKey)) return;
    pendingRewardKeys.add(rewardKey);
    const tierButtons = [...document.querySelectorAll('[data-cosmeau-gift]')].filter((candidate) => candidate.dataset.key === rewardKey);
    tierButtons.forEach((candidate) => { candidate.disabled = true; });
    let succeeded = false;
    try {
      const cart = await fetchCart();
      const total = eligibleTotal(cart);
      const threshold = Number(button.dataset.threshold);
      if (!marketRewardsEnabled || total < threshold || selectedRewardKeys(cart).has(rewardKey)) throw new Error(text('reward_unavailable'));
      const added = await addItems([{ id: Number(button.dataset.variant), quantity: 1, properties: { _cosmeau_auto_reward_key: rewardKey, _cosmeau_auto_reward_threshold: String(threshold) } }]);
      await preserveG6TinAfterRewardAdd(cart, added.cart);
      succeeded = true;
    } catch (error) {
      console.error('[CosmeauCart] gift add failed', error);
      const copy = button.querySelector('span');
      if (copy) copy.textContent = text('retry');
    } finally {
      pendingRewardKeys.delete(rewardKey);
      if (!succeeded) tierButtons.forEach((candidate) => { candidate.disabled = false; });
    }
  }

  async function addUpsell(button, variantId) {
    if (!button || !variantId) return;
    button.disabled = true;
    button.classList.add('is-adding');
    button.setAttribute('aria-busy', 'true');
    try {
      await addItems([{ id: Number(variantId), quantity: 1 }]);
      closeVariantSheet();
    } catch (error) {
      console.error('[CosmeauCart] upsell add failed', error);
      button.disabled = false;
      button.classList.remove('is-adding');
      button.removeAttribute('aria-busy');
      window.CosmeauCartNotice?.show?.(text('not_added'), error.message || text('retry'));
    }
  }

  async function changeLinePlan(select) {
    const drawer = document.querySelector('cart-drawer[data-cosmeau-cart]');
    const previous = select.dataset.previousValue ?? select.querySelector('option[selected]')?.value ?? '';
    const planId = String(select.value || '').trim();
    let properties = {};
    try {
      const parsedProperties = JSON.parse(select.dataset.lineProperties || '{}') || {};
      properties = Array.isArray(parsedProperties) ? Object.fromEntries(parsedProperties) : parsedProperties;
    } catch (_) {}
    properties._selling_plan_id = '';
    select.disabled = true;
    select.closest('.cart-item')?.classList.add('is-updating-plan');
    try {
      const response = await fetch(`${rootUrl()}cart/change.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(select.dataset.lineIndex || 1),
          quantity: Number(select.dataset.quantity || 1),
          selling_plan: planId || null,
          properties,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state?.errors) throw new Error(state?.description || state?.errors || text('purchase_type_error'));
      const updatedItem = state.items?.[Math.max(0, Number(select.dataset.lineIndex || 1) - 1)];
      const appliedPlan = String(updatedItem?.selling_plan_allocation?.selling_plan?.id || '');
      if (appliedPlan !== planId) throw new Error(text('plan_save_error'));
      drawer?.renderContents?.(state);
      await sync(state);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cosmeau-cart-plan', cartData: state });
      document.dispatchEvent(new CustomEvent('cart_changed', { detail: { source: 'cosmeau-cart-plan', cart: state } }));
    } catch (error) {
      console.error('[CosmeauCart] plan change failed', error);
      select.value = previous;
      select.disabled = false;
      select.closest('.cart-item')?.classList.remove('is-updating-plan');
    }
  }

  async function sync(cart) {
    if (syncing) { if (cart) queuedCart = cart; return; }
    const root = document.querySelector('[data-cosmeau-cart]');
    if (!root) return;
    syncing = true;
    try {
      let currentCart = cart || await fetchCart();
      const fingerprint = cartFingerprint(currentCart);
      if (fingerprint === renderedFingerprint) return currentCart;
      currentCart = await reconcileRewards(currentCart);
      const total = eligibleTotal(currentCart);
      root.classList.toggle('is-empty', currentCart.item_count === 0);
      renderRewards(root, currentCart, total);
      await renderUpsell(root, currentCart);
      renderedFingerprint = cartFingerprint(currentCart);
      return currentCart;
    } catch (error) { console.error('[CosmeauCart] sync failed', error); }
    finally {
      syncing = false;
      if (queuedCart) {
        const next = queuedCart;
        queuedCart = null;
        queueMicrotask(() => sync(next));
      }
    }
  }

  const boundedRemoteText = (value, maxLength, required = false) => {
    if (value == null && !required) return undefined;
    if (typeof value !== 'string') return null;
    const normalized = value.trim();
    if ((!normalized && required) || normalized.length > maxLength) return null;
    return normalized || undefined;
  };

  function safeRemoteImageUrl(value) {
    if (typeof value !== 'string' || !value || value.length > MAX_REMOTE_IMAGE_URL_LENGTH) return null;
    try {
      const parsed = new URL(value);
      if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return null;
      return parsed.href;
    } catch (_) { return null; }
  }

  function normalizeRemoteChoice(item) {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return null;
    if (!Number.isSafeInteger(item.variantId) || item.variantId <= 0) return null;
    const imageUrl = safeRemoteImageUrl(item.imageUrl);
    const title = boundedRemoteText(item.title, MAX_REMOTE_TITLE_LENGTH, true);
    if (!imageUrl || !title) return null;
    const normalized = { variantId: item.variantId, imageUrl, title };
    if (item.productId != null) {
      if (!Number.isSafeInteger(item.productId) || item.productId <= 0) return null;
      normalized.productId = item.productId;
    }
    const metadata = [
      ['productHandle', MAX_REMOTE_TITLE_LENGTH],
      ['productTitle', MAX_REMOTE_METADATA_LENGTH],
      ['variantTitle', MAX_REMOTE_METADATA_LENGTH],
      ['sku', MAX_REMOTE_METADATA_LENGTH],
    ];
    for (const [key, maxLength] of metadata) {
      const value = boundedRemoteText(item[key], maxLength);
      if (value === null) return null;
      if (value !== undefined) normalized[key] = value;
    }
    if (normalized.productHandle && !/^[a-z0-9][a-z0-9-]*$/.test(normalized.productHandle)) return null;
    return normalized;
  }

  function normalizeRemoteReward(reward, fallback) {
    if (!reward || typeof reward !== 'object' || Array.isArray(reward)) return null;
    if (reward.key !== fallback.key || reward.kind !== fallback.kind) return null;
    if (reward.active != null && typeof reward.active !== 'boolean') return null;
    if (!Number.isInteger(reward.thresholdMinor) || reward.thresholdMinor < 1 || reward.thresholdMinor > MAX_REMOTE_REWARD_THRESHOLD_MINOR) return null;
    const label = boundedRemoteText(reward.label, MAX_REMOTE_TITLE_LENGTH);
    if (label === null || !Array.isArray(reward.choices)) return null;
    const active = reward.active !== false;
    if (fallback.kind === 'shipping') {
      if (reward.choices.length) return null;
      return { ...fallback, active, thresholdMinor: reward.thresholdMinor, ...(label ? { label } : {}), choices: [] };
    }
    if (!active) {
      if (reward.choices.length > MAX_REMOTE_GIFT_CHOICES) return null;
      return { ...fallback, active: false, thresholdMinor: reward.thresholdMinor, ...(label ? { label } : {}), choices: [] };
    }
    if (!reward.choices.length || reward.choices.length > MAX_REMOTE_GIFT_CHOICES) return null;
    const choices = reward.choices.map(normalizeRemoteChoice);
    if (choices.some((item) => !item)) return null;
    const variantIds = new Set(choices.map((item) => item.variantId));
    if (variantIds.size !== choices.length) return null;
    return { ...fallback, active, thresholdMinor: reward.thresholdMinor, ...(label ? { label } : {}), choices };
  }

  function mergeRemoteConfig(remote) {
    if (remote?.enabled !== true || !Array.isArray(remote.rewards)) return;
    const fallbackByKey = new Map(fallbackConfig.rewards.map((reward) => [reward.key, reward]));
    const remoteByKey = new Map();
    for (const reward of remote.rewards) {
      const fallback = fallbackByKey.get(reward?.key);
      if (!fallback || remoteByKey.has(reward.key)) return;
      const normalized = normalizeRemoteReward(reward, fallback);
      if (!normalized) return;
      remoteByKey.set(reward.key, normalized);
    }
    const mergedRewards = fallbackConfig.rewards.map((fallback) => {
      const current = remoteByKey.get(fallback.key);
      const merged = current || fallback;
      return { ...merged, thresholdMinor: fallback.thresholdMinor };
    }).filter((reward) => reward.active !== false).sort((left, right) => left.thresholdMinor - right.thresholdMinor);
    if (mergedRewards.some((reward, index) => index > 0 && reward.thresholdMinor < mergedRewards[index - 1].thresholdMinor)) return;
    config = {
      enabled: true,
      rewards: mergedRewards,
      upsells: fallbackConfig.upsells,
    };
  }

  async function loadConfig() {
    if (!marketRewardsEnabled) return;
    const root = document.querySelector('[data-cosmeau-cart]');
    const url = root?.dataset.configUrl;
    if (!url) return;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 1500);
    try {
      const response = await fetch(url, { mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) return;
      const data = await response.json();
      mergeRemoteConfig(data?.config);
    } catch (error) { console.warn('[CosmeauCart] using safe embedded config', error); }
    finally { window.clearTimeout(timeout); }
  }

  document.addEventListener('click', (event) => {
    const checkoutControl = event.target.closest(CHECKOUT_SELECTOR);
    guardCheckoutEvent(event, checkoutControl);
  }, true);

  document.addEventListener('submit', (event) => {
    if (event.target?.id !== 'CartDrawer-Form') return;
    const checkoutControl = event.submitter || event.target.querySelector('#CartDrawer-Checkout');
    guardCheckoutEvent(event, checkoutControl);
  }, true);

  ['pointerdown', 'pointerup', 'touchmove', 'wheel'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      const root = event.target?.closest?.('[data-cosmeau-cart]');
      const panel = root?.querySelector('.cosmeau-cart__gift-panel');
      if (panel) pauseGiftAttention(panel);
    }, { capture: true, passive: true });
  });
  document.addEventListener('scroll', (event) => {
    const root = document.querySelector('[data-cosmeau-cart]');
    const target = event.target;
    if (!root || (target !== document && target !== window && !root.contains(target))) return;
    pauseGiftAttention(root.querySelector('.cosmeau-cart__gift-panel'));
  }, { capture: true, passive: true });

  document.addEventListener('click', (event) => {
    const continueWarning = event.target.closest('[data-cosmeau-gift-warning-continue]');
    if (continueWarning) {
      event.preventDefault();
      continueCheckoutFromGiftWarning();
      return;
    }
    const chooseWarning = event.target.closest('[data-cosmeau-gift-warning-choose]');
    if (chooseWarning) {
      event.preventDefault();
      closeGiftWarning(true);
      return;
    }
    const discountInfoToggle = event.target.closest('[data-cosmeau-discount-info-toggle]');
    if (discountInfoToggle) {
      event.preventDefault();
      const info = discountInfoToggle.parentElement?.querySelector('[data-cosmeau-discount-info]');
      const expanded = discountInfoToggle.getAttribute('aria-expanded') === 'true';
      discountInfoToggle.setAttribute('aria-expanded', String(!expanded));
      if (info) info.hidden = expanded;
      return;
    }
    const gift = event.target.closest('[data-cosmeau-gift]');
    if (gift) { event.preventDefault(); addGift(gift); return; }
    const scroll = event.target.closest('[data-cosmeau-gift-scroll]');
    if (scroll) {
      event.preventDefault();
      const track = scroll.closest('.cosmeau-cart__gift-panel')?.querySelector('[data-cosmeau-gift-track]');
      track?.scrollBy({ left: Number(scroll.dataset.cosmeauGiftScroll) * Math.max(180, track.clientWidth * .78), behavior: 'smooth' });
      return;
    }
    const closeSheet = event.target.closest('[data-cosmeau-variant-close]');
    if (closeSheet) {
      event.preventDefault();
      const sheet = closeSheet.closest('[data-cosmeau-variant-sheet]');
      const returnFocus = sheet?._returnFocus;
      closeVariantSheet();
      returnFocus?.focus?.();
      return;
    }
    const productTrigger = event.target.closest('[data-cosmeau-product-info-trigger]');
    if (productTrigger) {
      event.preventDefault();
      openProductSheet(productTrigger);
      return;
    }
    const closeProduct = event.target.closest('[data-cosmeau-product-close]');
    if (closeProduct) {
      event.preventDefault();
      const returnFocus = closeProduct.closest('[data-cosmeau-product-sheet]')?._returnFocus;
      closeProductSheet();
      returnFocus?.focus?.();
      return;
    }
    const variant = event.target.closest('[data-cosmeau-upsell-variant]');
    if (variant) {
      event.preventDefault();
      addUpsell(variant, variant.dataset.cosmeauUpsellVariant);
      return;
    }
    const upsell = event.target.closest('[data-cosmeau-upsell-product]');
    if (upsell) {
      event.preventDefault();
      const product = recommendationProducts.get(upsell.dataset.cosmeauUpsellProduct);
      if (!product) return;
      openVariantSheet(product, upsell);
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-cosmeau-plan-select]');
    if (!select) return;
    select.dataset.previousValue = select.querySelector('option[selected]')?.value || '';
    changeLinePlan(select);
  });
  document.addEventListener('keydown', (event) => {
    const giftWarning = document.querySelector('[data-cosmeau-gift-warning]:not([hidden])');
    if (event.key === 'Tab' && giftWarning) {
      trapSheetFocus(event, giftWarning);
      return;
    }
    if (event.key === 'Escape' && giftWarning) {
      event.preventDefault();
      giftWarningEscapeBlockUntil = Date.now() + 500;
      closeGiftWarning(true);
      return;
    }
    const activeSheet = document.querySelector('[data-cosmeau-variant-sheet]:not([hidden]), [data-cosmeau-product-sheet]:not([hidden])');
    if (event.key === 'Tab' && activeSheet) {
      trapSheetFocus(event, activeSheet);
      return;
    }
    if (event.key !== 'Escape') return;
    const sheet = document.querySelector('[data-cosmeau-variant-sheet]:not([hidden])');
    if (sheet) {
      const returnFocus = sheet._returnFocus;
      closeVariantSheet();
      returnFocus?.focus?.();
      return;
    }
    const productSheet = document.querySelector('[data-cosmeau-product-sheet]:not([hidden])');
    if (productSheet) {
      const returnFocus = productSheet._returnFocus;
      closeProductSheet();
      returnFocus?.focus?.();
    }
  });
  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape' || Date.now() > giftWarningEscapeBlockUntil) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('cart:refresh', () => refreshSections(true).catch((error) => console.error('[CosmeauCart] section refresh failed', error)));
  document.addEventListener('cart_changed', (event) => { if (event.detail?.source !== 'cosmeau-cart') sync(event.detail?.cart); });
  document.addEventListener('cart:updated', (event) => sync(event.detail?.cart));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => sync(event.cartData));
  }

  window.CosmeauCartDrawer = { sync, refreshSections, addItems, nextReward, eligibleTotal, progressPercent, changeLinePlan, reconcileRewards, preserveG6TinAfterRewardAdd, showPendingItem, clearPendingItem, openProductSheet, closeProductSheet, openGiftWarning, closeGiftWarning, guardCheckoutEvent };
  loadConfig().finally(async () => {
    let gatedCart = null;
    try { gatedCart = await ensureDevDiscountGate(); }
    catch (error) { console.error('[CosmeauCart] DEV discount gate failed closed', error); }
    await sync(gatedCart);
  }).catch((error) => console.error('[CosmeauCart] initial sync failed', error));
})();
